<template>
  <b-modal
    id="new-add-employee-planning"
    ref="modal"
    header-class="headerModal"
    centered
    :title="`${$t('AddEmployee')}: ${platformName}`"
    size="l"
    hide-footer
    @close="onCancel"
  >
    <b-form-group
      :label="$t('Filiale')"
      style="width:100%;"
    >
      <vue-select
        id="input-5"
        v-model="$v.store.$model"
        required
        :state="validateState('store')"
        :options="getFilialesByPlatforms"
        label="storeName"
        :clearable="false"
        :placeholder="$t('Select')"
      />
      <p
        v-if="$v.store.$anyError && buttonSubmited"
        style="color:red;"
      >{{ $t('This_is_a_required_field') }}
      </p>
    </b-form-group>
    <div style="display:flex;gap:10px;">
      <b-form-checkbox
        id="checkbox-2"
        v-model="isCheckedToday"
        name="checkbox-2"
        :value="true"
        :unchecked-value="false"
        @input="setToday(isCheckedToday)"
      >
        {{ $t('Today') }}
      </b-form-checkbox>
      <b-form-checkbox
        id="checkbox-1"
        v-model="isChecked"
        name="checkbox-1"
        :value="true"
        :unchecked-value="false"
        @input="setDefaultTime(isChecked)"
      >
        {{ $t('AllDay') }}
      </b-form-checkbox>
      <b-form-checkbox
        id="checkbox-2"
        v-model="isCheckedMorning"
        name="checkbox-2"
        :value="true"
        :unchecked-value="false"
        @input="setMorning(isCheckedMorning)"
      >
        {{ $t('Morning') }}
      </b-form-checkbox>
      <b-form-checkbox
        id="checkbox-1"
        v-model="isCheckedAfternoon"
        name="checkbox-1"
        :value="true"
        :unchecked-value="false"
        @input="setAfternoon(isCheckedAfternoon)"
      >
        {{ $t('Afternoon') }}
      </b-form-checkbox>
    </div>
    <div style="display: flex; justify-content: space-between;margin-top:10px;">
      <b-form-group
        :label="$t('StartingDate')"
      >
        <date-picker
          v-model="$v.startDate.$model"
          type="datetime"
          :placeholder="$t('Select')"
          aria-describedby="input-1-live-feedback"
          :lang="lang"
        />
        <p
          v-if="$v.startDate.$anyError && buttonSubmited"
          style="color:red;"
        >{{ $t('This_is_a_required_field') }}
        </p>
      </b-form-group>
      <b-form-group
        :label="$t('EndingDate')"
      >
        <date-picker
          v-model="$v.endDate.$model"
          type="datetime"
          :disabled="startDate == null"
          :placeholder="$t('Select')"
          :lang="lang"
        />
        <p
          v-if="$v.endDate.$anyError && buttonSubmited"
          style="color:red;"
        >{{ $t('This_is_a_required_field') }}
        </p>
      </b-form-group>
    </div>
    <b-form-group
      :label="$t('Employeers')"
      style="width:100%;  margin-right: 10px;"
      label-for="dummy-id"
    >
      <vue-select
        v-model="$v.employees.$model"
        required
        aria-multiline="2"
        multiple
        :options="destinationOptions"
        label="userFullName"
        :reduce="(e) => e.userId"
        :clearable="false"
        :placeholder="$t('Select')"
      />
      <p
        v-if="$v.employees.$anyError && buttonSubmited"
        style="color:red;"
      >{{ $t('This_is_a_required_field') }}
      </p>
    </b-form-group>
    <div
      style="margin-top: 5px;"
    >
      <b-button
        type="button"
        variant="none"
        class="buttonSubmit"
        @click="onSubmit"
      >
        {{ $t("Submit") }}
      </b-button>
      <b-button
        type="button"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px"
        @click="onCancel"
      >
        {{ $t("Cancel") }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import {
  required,
} from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

export default {
  components: {
    DatePicker,
  },
  mixins: [validationMixin],
  props: ['platformName'],
  data() {
    return {
      store: null,
      startDate: null,
      endDate: null,
      employees: [],
      isCheckedMorning: false,
      isCheckedAfternoon: false,
      isCheckedToday: false,
      isChecked: false,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
      buttonSubmited: false,
    };
  },
  validations: {
    store: {
      required,
    },
    startDate: {
      required,
    },
    endDate: {
      required,
    },
    employees: {
      required,
    },
  },
  computed: {
    ...mapGetters(['getFilialesByPlatforms', 'getFreeEmployeesNewPlatform']),
    destinationOptions() {
      return this.getFreeEmployeesNewPlatform.filter((filiale) => {
        return filiale.userId !== this.employees
      })
    },
  },
  watch: {
    startDate(value) {
      if (value == null) {
        this.isCheckedMorning = false;
        this.isCheckedAfternoon = false;
        this.isCheckedToday = false;
        this.isChecked = false;
        this.endDate = null
      }
    },
    endDate(value) {
      if (value) {
        this.freeEmployees_new_Platform({
          startShift: this.startDate,
          endShift: value,
        })
      } else {
        this.isCheckedMorning = false;
        this.isCheckedAfternoon = false;
        this.isCheckedToday = false;
        this.isChecked = false;
      }
    },
  },
  methods: {
    ...mapActions(['freeEmployees_new_Platform']),
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    setToday(isChecked) {
      if (isChecked) {
        const today = moment().set({
          hour: 8, minute: 0, second: 0, millisecond: 0,
        }).toDate();
        const endToday = moment().set({
          hour: 17, minute: 0, second: 0, millisecond: 0,
        }).toDate();

        this.startDate = today;
        this.endDate = endToday;
        this.isCheckedMorning = false;
        this.isCheckedAfternoon = false;
        this.isChecked = false;
      }
    },

    setDefaultTime(isChecked) {
      if (isChecked) {
        const selectedStart = this.startDate ? moment(this.startDate) : moment();

        this.startDate = selectedStart.set({
          hour: 8, minute: 0, second: 0, millisecond: 0,
        }).toDate();
        this.endDate = selectedStart.set({
          hour: 17, minute: 0, second: 0, millisecond: 0,
        }).toDate();
        this.isCheckedMorning = false;
        this.isCheckedAfternoon = false;
        this.isCheckedToday = false;
      }
    },

    setMorning(isChecked) {
      if (isChecked) {
        const selectedStart = this.startDate ? moment(this.startDate) : moment();
        this.startDate = selectedStart.set({
          hour: 8, minute: 0, second: 0, millisecond: 0,
        }).toDate();
        this.endDate = selectedStart.set({
          hour: 12, minute: 30, second: 0, millisecond: 0,
        }).toDate();
        this.isCheckedAfternoon = false;
        this.isCheckedToday = false;
        this.isChecked = false;
      }
    },

    setAfternoon(isChecked) {
      if (isChecked) {
        const selectedStart = this.startDate ? moment(this.startDate) : moment();
        this.startDate = selectedStart.set({
          hour: 12, minute: 30, second: 0, millisecond: 0,
        }).toDate();
        this.endDate = selectedStart.set({
          hour: 17, minute: 0, second: 0, millisecond: 0,
        }).toDate();
        this.isCheckedMorning = false;
        this.isCheckedToday = false;
        this.isChecked = false;
      }
    },
    onSubmit() {
      this.buttonSubmited = true
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      const object = {
        platform: this.platformName,
        storeId: this.store.storeId,
        storeGln: this.store.storeGLN,
        employeeUserIds: this.employees,
        startDate: this.startDate,
        endDate: this.endDate,
        isCarpenter: false,
      }
      this.$emit('addPersonalPlanning', object)
      this.onReset();
    },
    onCancel() {
      this.onReset();
    },
    onReset() {
      this.store = null
      this.startDate = null;
      this.endDate = null;
      this.isCheckedMorning = false;
      this.isCheckedAfternoon = false;
      this.isCheckedToday = false;
      this.isChecked = false;
      this.employees = []
      this.buttonSubmited = false
      this.$refs.modal.hide();
    },
  },
};
</script>

  <style lang="scss" scoped>
  </style>
